module.exports = __webpack_public_path__ + "img/delete-background-icon.59cd3f9d.svg";